import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import PosSection from "./posSection/PosSection";
import GridItem from "./displaySection/GridItem";
import api from "../../api";
import { addItemToCart, updateCartItem } from "../../actions/cart";

class Sale extends Component {
  state = {
    products: [],
    categories: [],
    selectedCategory: null,

    cashiers: [],
    selectedCashierId: "",
    cashiersLoading: false,

    page: 1,
    perPage: 20,
    total: 0,
    totalPages: 0,
    loading: true,
    categoriesLoading: true,
    error: false,
    categoriesError: false
  };

  componentDidMount() {
    this.loadProducts(1, null);
    this.loadCategories();
    this.loadCashiers();
  }

  loadProducts = async (page = 1, category = this.state.selectedCategory) => {
    this.setState({
      loading: true,
      error: false
    });

    try {
      const response = await api.product.fetchPage(
        page,
        this.state.perPage,
        category
      );

      const posResponse = await api.posProduct.fetchByPages(100, 1);

      console.log(
        "WooCommerce paginated products response:",
        response.data
      );

      console.log(
        "POS products response:",
        posResponse.data
      );

      const data = response.data || {};

      const wooProducts = Array.isArray(data.products)
        ? data.products
        : Array.isArray(data.value)
          ? data.value
          : Array.isArray(data)
            ? data
            : [];

      const posProducts = Array.isArray(posResponse.data)
        ? posResponse.data.map(product => ({
            ...product,
            price: Number(product.sellingPrice || 0),
            sellingPrice: Number(product.sellingPrice || 0),
            stockQuantity: Number(product.stockQuantity || 0),
            images: product.image
              ? [{ src: product.image }]
              : [],
            source: "POS"
          }))
        : [];

      this.setState({
        products: [...wooProducts, ...posProducts],
        page: Number(data.page || page),
        total:
          Number(data.total || 0) +
          posProducts.length,
        totalPages: Number(
          data.totalPages ||
          data.total_pages ||
          1
        ),
        loading: false,
        error: false
      });
    } catch (error) {
      console.error(
        "Failed to load Sale products:",
        error
      );

      this.setState({
        products: [],
        total: 0,
        totalPages: 0,
        loading: false,
        error: true
      });
    }
  };

  loadCategories = async () => {
    try {
      const response = await api.product.fetchCategories();
      const data = response.data;

      this.setState({
        categories:
          Array.isArray(data)
            ? data
            : data && Array.isArray(data.value)
              ? data.value
              : [],
        categoriesLoading: false,
        categoriesError: false
      });
    } catch (error) {
      console.error(
        "Failed to load WooCommerce categories:",
        error
      );

      this.setState({
        categories: [],
        categoriesLoading: false,
        categoriesError: true
      });
    }
  };
  loadCashiers = async () => {
    try {
      this.setState({ cashiersLoading: true });

      const response = await api.user.fetchByPages(100, 1);

      const users = Array.isArray(response.data)
        ? response.data
        : [];

      const cashiers = users.filter(
        user => Number(user.role) === 2
      );

      this.setState(prevState => {
        let selectedCashierId = prevState.selectedCashierId;

        try {
          const savedCashierId = localStorage.getItem(
            "posSelectedCashierId"
          );

          if (
            savedCashierId &&
            cashiers.some(
              cashier =>
                String(cashier.id) === String(savedCashierId)
            )
          ) {
            selectedCashierId = String(savedCashierId);
          }
        } catch (error) {
          console.warn(
            "Could not read saved cashier:",
            error
          );
        }

        if (
          !selectedCashierId ||
          !cashiers.some(
            cashier =>
              String(cashier.id) === String(selectedCashierId)
          )
        ) {
          selectedCashierId =
            cashiers.length > 0
              ? String(cashiers[0].id)
              : "";
        }

        const selectedCashier = cashiers.find(
          cashier =>
            String(cashier.id) === String(selectedCashierId)
        );

        try {
          if (selectedCashier) {
            localStorage.setItem(
              "posSelectedCashierId",
              String(selectedCashier.id)
            );

            localStorage.setItem(
              "posSelectedCashierName",
              selectedCashier.name
            );
          }
        } catch (error) {
          console.warn(
            "Could not save selected cashier:",
            error
          );
        }

        return {
          cashiers,
          selectedCashierId,
          cashiersLoading: false
        };
      });

      console.log("Cashiers loaded:", cashiers);
    } catch (error) {
      console.error(
        "Failed to load cashiers:",
        error
      );

      this.setState({
        cashiers: [],
        selectedCashierId: "",
        cashiersLoading: false
      });
    }
  };
  handleCashierChange = event => {
    const selectedCashierId = String(event.target.value);

    const selectedCashier = this.state.cashiers.find(
      cashier =>
        String(cashier.id) === selectedCashierId
    );

    this.setState({
      selectedCashierId
    });

    try {
      localStorage.setItem(
        "posSelectedCashierId",
        selectedCashierId
      );

      localStorage.setItem(
        "posSelectedCashierName",
        selectedCashier
          ? selectedCashier.name
          : ""
      );
    } catch (error) {
      console.warn(
        "Could not save selected cashier:",
        error
      );
    }
  };
  handleCategorySelect = categoryId => {
    this.setState(
      {
        selectedCategory: categoryId,
        page: 1
      },
      () => {
        this.loadProducts(1, categoryId);
      }
    );
  };

  handlePageChange = page => {
    const { totalPages, selectedCategory } = this.state;

    if (
      page < 1 ||
      page > totalPages ||
      page === this.state.page ||
      this.state.loading
    ) {
      return;
    }

    this.loadProducts(page, selectedCategory);
  };

  handleProductSelect = product => {
    const { cart } = this.props;
    const existingItem = cart.items[product.id];

    if (existingItem) {
      this.props.updateCartItem({
        ...existingItem,
        qty: existingItem.qty + 1
      });
    } else {
      this.props.addItemToCart({
        ...product,
        qty: 1,
        discount: 0,
        sellingPrice: product.price,
        totalPrice: product.price
      });
    }
  };

  renderPagination = () => {
    const {
      page,
      totalPages,
      loading
    } = this.state;

    if (totalPages <= 1) {
      return null;
    }

    const pages = [];

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i += 1) {
        pages.push(i);
      }
    } else {
      pages.push(1);

      if (page > 4) {
        pages.push("...");
      }

      const start = Math.max(2, page - 1);
      const end = Math.min(totalPages - 1, page + 1);

      for (let i = start; i <= end; i += 1) {
        pages.push(i);
      }

      if (page < totalPages - 3) {
        pages.push("...");
      }

      pages.push(totalPages);
    }

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 6,
          marginTop: 24,
          paddingBottom: 10,
          flexWrap: "wrap"
        }}
      >
        <button
          onClick={() => this.handlePageChange(page - 1)}
          disabled={page === 1 || loading}
          style={{
            border: "1px solid #dce7e2",
            background: page === 1 || loading ? "#f5f5f5" : "#fff",
            color: page === 1 || loading ? "#aaa" : "#444",
            borderRadius: 10,
            padding: "7px 12px",
            cursor: page === 1 || loading ? "default" : "pointer"
          }}
        >
          Previous
        </button>

        {pages.map((pageNumber, index) =>
          pageNumber === "..." ? (
            <span
              key={`ellipsis-${index}`}
              style={{
                padding: "7px 4px",
                color: "#777"
              }}
            >
              ...
            </span>
          ) : (
            <button
              key={pageNumber}
              onClick={() => this.handlePageChange(pageNumber)}
              disabled={loading}
              style={{
                minWidth: 36,
                border: "1px solid #dce7e2",
                borderRadius: 10,
                padding: "7px 10px",
                background:
                  pageNumber === page ? "#16845b" : "#fff",
                color:
                  pageNumber === page ? "#fff" : "#444",
                fontWeight:
                  pageNumber === page ? 600 : 400,
                cursor: loading ? "default" : "pointer"
              }}
            >
              {pageNumber}
            </button>
          )
        )}

        <button
          onClick={() => this.handlePageChange(page + 1)}
          disabled={page === totalPages || loading}
          style={{
            border: "1px solid #dce7e2",
            background:
              page === totalPages || loading ? "#f5f5f5" : "#fff",
            color:
              page === totalPages || loading ? "#aaa" : "#444",
            borderRadius: 10,
            padding: "7px 12px",
            cursor:
              page === totalPages || loading
                ? "default"
                : "pointer"
          }}
        >
          Next
        </button>
      </div>
    );
  };

  render() {
    const { classes } = this.props;

    const {
      products,
      categories,
      selectedCategory,
      loading,
      error,
      categoriesLoading,
      categoriesError,
      page,
      total,
      totalPages
    } = this.state;

    return (
      <div className={classes.pageContainer}>

        {/* PREMIUM POS TOP BAR */}
        <div className={classes.topBar}>
          <div className={classes.topBarLeft}>

            <div className={classes.brandMark}>
              PV
            </div>

            <div>
              <div className={classes.brandName}>
                SOLACEHEALTHHUB
              </div>

              <div className={classes.brandSubtitle}>
                Point of Sale
              </div>
            </div>

            <div className={classes.posBadge}>
              POS / SALES
            </div>

          </div>

          <div className={classes.topBarRight}>

            <div className={classes.connectionStatus}>
              <span className={classes.statusDot}></span>
              WooCommerce Connected
            </div>
            <div
              className={classes.cashier}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10
              }}
            >

              <div className={classes.cashierIcon}>
                {(() => {
                  const selectedCashier = this.state.cashiers.find(
                    cashier =>
                      String(cashier.id) ===
                      String(this.state.selectedCashierId)
                  );

                  return selectedCashier
                    ? selectedCashier.name.charAt(0).toUpperCase()
                    : "C";
                })()}
              </div>

              <div>
                <div className={classes.cashierName}>
                  {this.state.cashiersLoading
                    ? "Loading..."
                    : (() => {
                        const selectedCashier = this.state.cashiers.find(
                          cashier =>
                            String(cashier.id) ===
                            String(this.state.selectedCashierId)
                        );

                        return selectedCashier
                          ? selectedCashier.name
                          : "Select Cashier";
                      })()}
                </div>

                <div className={classes.cashierRole}>
                  Cashier
                </div>
              </div>

              <select
                value={this.state.selectedCashierId}
                onChange={this.handleCashierChange}
                disabled={
                  this.state.cashiersLoading ||
                  this.state.cashiers.length === 0
                }
                style={{
                  marginLeft: 6,
                  padding: "7px 28px 7px 8px",
                  borderRadius: 6,
                  border: "1px solid #d8e2de",
                  background: "#ffffff",
                  color: "#24312d",
                  fontSize: 13,
                  fontWeight: 600,
                  cursor: "pointer",
                  outline: "none"
                }}
              >
                {this.state.cashiers.length === 0 ? (
                  <option value="">
                    No cashiers available
                  </option>
                ) : (
                  this.state.cashiers.map(cashier => (
                    <option key={cashier.id} value={String(cashier.id)}>
                      {cashier.name}
                    </option>
                  ))
                )}
              </select>

              <span className={classes.chevron}>
                v
              </span>

            </div>

          </div>
        </div>

        <div className={classes.flexContainer}>

        {/* LEFT: PRODUCT CATALOG */}
        <div className={classes.items}>

          <div className={classes.catalogHeader}>
            <div>
              <h2 className={classes.catalogTitle}>
                PRODUCTS
              </h2>

              <p className={classes.catalogSubtitle}>
                {total > 0
                  ? `${total.toLocaleString()} products`
                  : "Select a product to add it to the current sale"}
              </p>
            </div>
          </div>

          {/* WOOCOMMERCE CATEGORIES */}
          <div
            style={{
              display: "flex",
              gap: 10,
              marginBottom: 22,
              flexWrap: "wrap",
              maxHeight: 110,
              overflowY: "auto",
              paddingRight: 4
            }}
          >
            <button
              onClick={() => this.handleCategorySelect(null)}
              style={{
                border:
                  selectedCategory === null
                    ? "none"
                    : "1px solid #ddd",
                borderRadius: 999,
                padding: "9px 17px",
                background:
                  selectedCategory === null
                    ? "#16845b"
                    : "#ffffff",
                color:
                  selectedCategory === null
                    ? "#fff"
                    : "#444",
                fontWeight: 600,
                cursor: "pointer"
              }}
            >
              All
            </button>

            {categoriesLoading && (
              <span
                style={{
                  fontSize: 12,
                  color: "#71817b",
                  padding: "8px 4px"
                }}
              >
                Loading categories...
              </span>
            )}

            {categoriesError && (
              <span
                style={{
                  fontSize: 12,
                  color: "#b91c1c",
                  padding: "8px 4px"
                }}
              >
                Unable to load categories.
              </span>
            )}

            {!categoriesLoading &&
              !categoriesError &&
              categories.map(category => (
                <button
                  key={category.id}
                  onClick={() =>
                    this.handleCategorySelect(category.id)
                  }
                  style={{
                    border:
                      selectedCategory === category.id
                        ? "none"
                        : "1px solid #ddd",
                    borderRadius: 999,
                    padding: "9px 15px",
                    background:
                      selectedCategory === category.id
                        ? "#16845b"
                        : "#ffffff",
                    color:
                      selectedCategory === category.id
                        ? "#fff"
                        : "#444",
                    cursor: "pointer",
                    fontWeight:
                      selectedCategory === category.id
                        ? 600
                        : 400
                  }}
                >
                  {String(category.name || "").replace(
                    /&amp;/g,
                    "&"
                  )}
                  {" "}
                  ({category.count || 0})
                </button>
              ))}
          </div>
          {loading && (
            <p>
              Loading WooCommerce products...
            </p>
          )}

          {error && (
            <p>
              Unable to load WooCommerce products.
            </p>
          )}

          {!loading &&
            !error &&
            products.length === 0 && (
              <p>
                No products found in this category.
              </p>
            )}

          {!loading &&
            !error &&
            products.length > 0 && (
              <div className={classes.productGrid}>
                {products.map(product => (
                  <GridItem
                    key={product.id}
                    product={product}
                    onSelect={this.handleProductSelect}
                  />
                ))}
              </div>
            )}

          {!loading && !error && totalPages > 1 && (
            <div>
              <div
                style={{
                  textAlign: "center",
                  marginTop: 16,
                  fontSize: 12,
                  color: "#71817b"
                }}
              >
                Page {page} of {totalPages}
              </div>

              {this.renderPagination()}
            </div>
          )}

        </div>

        {/* RIGHT: CURRENT SALE */}
        <div className={classes.pos}>
          <PosSection />        </div>

      </div>
      </div>
    );
  }
}

const mapStateToProps = ({ cart }) => ({
  cart
});

export default connect(
  mapStateToProps,
  {
    addItemToCart,
    updateCartItem
  }
)(withStyles(styles, { withTheme: true })(Sale));




































